define('modules/editor/models/property_groups/video_content',['require','exports','module','./base'],function(require, exports, module){
  "use strict";
  var BasePropertyGroup = require("./base");
  module.exports = BasePropertyGroup.extend({
    name: "video:content",
    editAllowed: false,
    properties: ["content"],
    applyStyles: function($el){
      $el.find(".js-videocontent").html(this.get("content"));
    }
  });
});

